import AppForms from "@toothfairy/shared-ui/AppForms";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import { View } from "react-native";
import ToothFairyButton from "../../../../Components/ToothFairyComponents/ToothFairyButton";
import Constants from "../../../../Constants";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useSections from "../../../../Hooks/useSections";
import useWorkspaces from "../../../../Hooks/useWorkspaces";
import { isLargeScreen } from "../../../MainViewContainer";

const DictionarySettingsAIView = ({ isEdit, settingType, handleDeletion }) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();
  const entityName = t('settings.dictionary.dictionaryMapping');

  const { state } = AppStateManager.useAppStateManager();
  const { getWorkspaceBaseModel } = useWorkspaces();
  const _title = useCallback(() => {
    return isEdit ? t('common.save') : t('common.create');
  }, [entityName, isEdit]);
  const { setFieldValue, values } = AppForms.useFormikContext();
  useEffect(() => {
    if (values?.sourceLanguage !== "en" && values?.targetLanguage !== "en")
      setFieldValue("targetLanguage", "en");
  }, [values?.sourceLanguage]);
  useEffect(() => {
    if (values?.sourceLanguage !== "en" && values?.targetLanguage !== "en")
      setFieldValue("sourceLanguage", "en");
  }, [values?.targetLanguage]);

  return (
    <>
      <>
        <View>
          <AppForms.AppFormDropDown
            isElevated={false}
            dropDownStyle={{
              borderColor: currentTheme?.theme?.border_color,
              maxWidth: !isLargeScreen() && 250,
            }}
            showTextInputLabel
            label={t('settings.dictionary.sourceLanguage')}
            isMandatory
            name="sourceLanguage"
            items={state?.languagesConfig ? [...state?.languagesConfig] : []}
            propertyLabel="name"
            propertyValue="id"
            inputLabelStyle={{
              marginLeft: 5,
            }}
          />
          <AppForms.AppFormField
            showTextInputLabel
            isMandatory
            wrapperInputStyle={{
              paddingTop: 10,
            }}
            label={t('settings.dictionary.sourceText')}
            placeholder={t('settings.dictionary.sourceText')}
            keyboardtype="default"
            textContextType="label"
            autoCorrect={false}
            name="sourceText"
          />
        </View>

        <View>
          <AppForms.AppFormDropDown
            isElevated={false}
            dropDownStyle={{
              borderColor: currentTheme?.theme?.border_color,
              maxWidth: !isLargeScreen() && 250,
            }}
            showTextInputLabel
            label={t('settings.dictionary.targetLanguage')}
            isMandatory
            name="targetLanguage"
            items={state?.languagesConfig ? [...state?.languagesConfig] : []}
            propertyLabel="name"
            propertyValue="id"
            inputLabelStyle={{
              marginLeft: 5,
            }}
          />
          <AppForms.AppFormField
            showTextInputLabel
            isMandatory
            wrapperInputStyle={{
              paddingTop: 10,
            }}
            label={t('settings.dictionary.targetText')}
            placeholder={t('settings.dictionary.targetText')}
            keyboardtype="default"
            textContextType="label"
            autoCorrect={false}
            name="targetText"
          />
        </View>

        <AppForms.AppFormField
          showTextInputLabel
          label={t('common.description')}
          placeholder={t('common.description')}
          keyboardtype="default"
          textContextType="label"
          autoCorrect={false}
          name="description"
          multiline={true}
          numberOfLines={4}
          style={{
            marginTop: 2,
          }}
          wrapperInputStyle={{
            marginBottom: 20,
            marginTop: 10,
            marginRight: 5,
          }}
          textContainer={{
            marginTop: 5,
            marginLeft: 5,
            padding: 10,
            marginHorizontal: 0,
            minHeight: 100,
          }}
          type="text"
        />
      </>
      <View style={{ alignItems: "center" }}>
        <AppForms.AppSubmitButton
          title={_title()}
          awesomeIconColor={currentTheme?.theme?.white}
          backgroundColor={currentTheme?.theme?.primary}
          btnContentStyle={{
            paddingLeft: 0,
            paddingRight: 0,
          }}
          style={[
            {
              height: Constants.appButtonHeight,
              width: "auto",
              shadowColor: currentTheme?.theme?.transparent,
              marginHorizontal: 10,
            },
          ]}
          // btnLabelStyle={{ fontSize: 16 }}
          wrapperStyle={[
            {
              width: "fit-content",
              minWidth: 150,
              marginTop: 20,
              height: Constants.appButtonHeight,
            },
          ]}
        />
        {isEdit && (
          <ToothFairyButton
            title={t('settings.dictionary.delete')}
            onPress={handleDeletion}
            isDeletion
            wrapperStyle={{
              marginTop: 30,
              minWidth: 150,
              height: Constants.appButtonHeight,
            }}
          />
        )}
      </View>
    </>
  );
};

export default DictionarySettingsAIView;
